import { ApprovalReportLayout } from './ApprovalReportLayout';

export function CashCollectionPage() {
  return <ApprovalReportLayout title="Cash Collection" routeId="cashCollection" />;
}
